import { loader } from 'graphql.macro'

export default function resourceImports ({ dataLoaders, queryKey }) {
  const [, variables = {}] = queryKey
  const schema = loader('./resourceImports.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    first: variables.first,
    before: variables.before,
    after: variables.after,
    last: variables.last
  })
}
